import React from 'react';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';
import List from '../../components/List/List';
const linkResolver = require('../../../config/linkResolver');

const ArticleList = ({ input }) => (
  <StaticQuery
    query={graphql`
      query ArticleSliceQuery {
        allPrismicArticle(
          sort: { fields: last_publication_date, order: DESC }
        ) {
          edges {
            node {
              uid
              type
              last_publication_date(fromNow: true)
              data {
                seo_title
                seo_description
                seo_thumbnail {
                  url
                  alt
                }
              }
            }
          }
        }
      }
    `}
    render={data => {
      const articles = data.allPrismicArticle.edges;
      let articleList =
        articles &&
        articles.map(({ node }) => ({
          key: node.uid.toString(),
          type: 'inline',
          dest: linkResolver(node),
          thumbnail: {
            url: node.data.seo_thumbnail.url,
            alt: node.data.seo_thumbnail.alt,
          },
          title: node.data.seo_title,
          metaText: node.last_publication_date,
        }));

      return <List itemWidth={25} isFullWidth cards={articleList} />;
    }}
  />
);

ArticleList.propTypes = {
  input: PropTypes.object.isRequired,
};

export default ArticleList;

/*
  <FeatureArticles articles={data.allPrismicArticle.edges.slice(0, 1)}/>
  <ListArticles articles={data.allPrismicArticle.edges.slice(1)} />
*/
